{
  "base_password": "Contraseña",
  "base_loading": "Cargando...",
  "base_item": "Item",
  "base_date": "Fecha",
  "base_hour": "Hora",
  "base_description": "Descripción",
  "base_value": "Valor",
  "base_add": "Agregar",
  "base_submit": "Finalizar",
  "base_product": "Producto",
  "base_confirm": "Confirmar",
  "base_quantity": "Cant",
  "base_cancel": "Cancelar",
  "base_select": "Seleccione",
  "base_code": "Código",

  "account_myPurchases": "Mis compras",
  "account_view": "Visializar",
  "account_emptyNotice": "Ninguna compra encontrada",
  "account_previous": "Anterior",
  "account_next": "Siguiente",
  "account_itemsQuantity": "{quantity} item(s)",
  "account_sellNumber": "Orden #{orderCode}",
  "account_log_out_button": "Cerrar sesión",
  "account_total_purchases": "Total",
  "account_sale_item_without_date": "Sin programación",
  "account_sale_total_value": "Valor total",
  "account_sale_discount": "Descuento",
  "account_sale_date": "Data y hora",
  "account_sale_reschedule": "Reprogramar",
  "account_sale_reservation_tariff": "Tarifas",
  "account_sale_reservation_voucher": "acciones",
  "account_sale_reservation_places": "Lugares",
  "account_sale_checkout": "Finalizar la Compra",
  "account_sale_download_all": "Descargar todo",
  "account_sale_reschedule_disabled": "No es posible reprogramar reservas promocionales. Contáctese con el establecimiento para obtener más información",
  "account_sale_reschedule_success_message": "Reprogramación confirmada con éxito",
  "account_sale_voucher_revoketed": "Cancelado",
  "account_empty_state": "Todavía no tienes ninguna compra",
  "account_sale_package_title": "{packageName} con {quantity} actividades",
  "account_sale_reschedule_tooltip": "Las reservas promocionales no se pueden reprogramar. Para más información, contacte con el establecimiento.",
  "account_sale_voucher_pending": "Voucher Pendiente",
  "account_sale_pending_voucher_info": "Se ha confirmado el pago de su compra. <strong>El cupón se está generando</strong> con el socio y estará disponible próximamente.",
  "account_sale_download_all_vouchers_tooltip": "Voucher pendiente, esperar la confirmación",
  "account_sale_voucher_pending_status": "Esperando confirmación",
  "account_sale_change_amount": "Acréscimo por Reprogramación",
  "account_sale_original_total_value": "Valor original de la compra",
  "account_email_change_title": "Confirmación de cambio de e-mail",
  "account_email_change_confirm_title": "Sus datos de registro fueron actualizados.",
  "account_email_change_description": "Para continuar, ingresa tu e-mail actual. Validaremos el código enviado al nuevo e-mail.",
  "account_email_change_confirm_description": "<strong><em>{app}</em></strong> actualizó los datos de su registro.<br></br>¿Está de acuerdo en que sus datos sean actualizados en nuestra base de datos?",
  "account_email_change_current_email_label": "E-mail actual",
  "account_email_change_new_email_label": "Nuevo e-mail",
  "account_email_change_login_button": "Continuar",
  "account_email_change_confirm_button": "Estoy de acuerdo",
  "account_email_change_decline_button": "No estoy de acuerdo",
  "account_email_change_success": "Cambio de e-mail confirmado con éxito.",
  "account_email_change_declined": "El cambio de e-mail fue rechazado.",
  "account_email_change_invalid_link": "Este enlace de confirmación no es válido o está incompleto.",
  "account_email_change_error": "No fue posible completar el cambio de e-mail. Inténtalo de nuevo o solicita un nuevo enlace.",

  "reservation_download": "Descargar",
  "reservation_rescheduling": "Reprogramación...",
  "voucher_download": "Descargar",

  "reschedule_step_date": "Seleccione una fecha",
  "reschedule_step_time": "Selecciona una hora",
  "reschedule_step_summary": "confirmar la selección",
  "reschedule_go_back_button": "Regresa",
  "reschedule_confirm_button": "Confirmar",
  "reschedule_make_payment_button": "Realizar el pago",
  "reschedule_go_forward_button": "Continuar",
  "reschedule_selected_date": "Data Seleccionada",
  "reschedule_selected_time": "Tiempo seleccionado",
  "reschedule_error_reschedulingLimitExceeded": "Límite de reprogramaciones excedido",
  "reschedule_error_reschedulingToHigherTariffNotAllowed": "No es posible reprogramar para una tarifa de mayor valor",
  "reschedule_error_reschedulingToLowerTariffNotAllowed": "No es posible reprogramar para una tarifa de menor valor",
  "reschedule_error_reschedulingAntecedenceNotMet": "La antecedencia para reprogramación debe ser de al menos {minAntecedence}",
  "reschedule_error_scheduleTimeMustDifferFromCurrent": "La hora seleccionada debe ser diferente de la hora actual",
  "reschedule_error_schedulingIsValid": "La fecha seleccionada no es válida",
  "reschedule_error_invalidValue": "La fecha seleccionada no es válida",
  "reschedule_days": "{count, plural, one {{count, number} día} other {{count, number} días}}",
  "reschedule_hours": "{count, plural, one {{count, number} hora} other {{count, number} horas}}",
  "reschedule_minutes": "{count, plural, one {{count, number} minuto} other {{count, number} minutos}}",
  "reschedule_charge_summary_alert_title": "Asegúrese de que la nueva fecha está correcta",
  "reschedule_charge_summary_alert_description": "Su reserva actual está marcada para {date}. Después de confirmar, su entrada ya no tendrá acceso a esa fecha y tendrá {remainingRescheduleCount} reprogramación restante.",
  "reschedule_charge_summary_actual_schedule": "Reserva actual",
  "reschedule_charge_summary_new_schedule": "Nueva reserva",
  "reschedule_charge_summary_total_to_pay": "Total a pagar",
  "reschedule_charge_summary_disclaimer": "Su reserva del {date} está garantizada hasta que el reprogramación sea confirmada.",
  "reschedule_charge_summary_pay_button": "Realizar el pago",
  "reschedule_info_remaining_reschedule_count": "Reagendamentos disponibles: ",
  "reschedule_info_reschedule_until_title": "Plazo para solicitar reprogramación: ",
  "reschedule_history_old_reservation_value": "Reserva antigua: ",
  "reschedule_history_new_reservation_value": "Nueva reserva: ",
  "reschedule_applied_message": "Reprogramación confirmada",
  "reschedule_expired_message": "El pago para finalizar la reprogramación ha expirado",
  "reschedule_pending_payment_message": "Realice el pago para la reprogramación para la fecha {date} ser confirmada.",
  "reschedule_pending_payment_message_title": "Reprogramación en progreso",
  "reschedule_info_reschedule_until_expired": "El plazo para solicitar reprogramación ha expirado",
  "reschedule_error_saleItemHasPayableSaleChanges": "La reserva tiene un reprogramación pendiente de pago",

  "auth_processing": "Procesando...",
  "auth_checkoutHeaderTitle": "Ya tengo una cuenta",
  "auth_accountHeaderTitle": "Iniciar sesión",
  "auth_alreadyHaveAnAccount": "Ya tengo una cuenta",
  "auth_wantToSignup": "Quiero Inscribirse",
  "auth_signupPasswordInfo": "Debe contener al menos 8 caracteres, con al menos una letra mayúscula y una letra minúscula",
  "auth_inputEmail": "Escriba su e-mail",
  "auth_inputPassword": "Contraseña",
  "auth_labelPassword": "Contraseña",
  "auth_labelEmail": "E-mail",
  "auth_forgotPassword": "Olvidé mi contraseña",
  "auth_login": "Iniciar sesión",
  "auth_submit": "Enviar",
  "auth_registerMessage": "No tienes una cuenta? Registrarse",
  "auth_createAccount": "Crear una cuenta",
  "auth_labelName": "Nombre",
  "auth_labelSurname": "Apellido",
  "auth_mailConfirmation": "Confirmar E-mail",
  "auth_passwordConfirmation": "Confirmar Contraseña",
  "auth_cellphone": "Número de móvil",
  "auth_identity_cpf": "CPF",
  "auth_identity_cnpj": "CNPJ",
  "auth_cep": "CEP",
  "auth_corporate_name": "Nombre de empresa",
  "auth_cnpj_first_name": "Nombre del representante legal",
  "auth_cnpj_last_name": "Apellido del representante legal",
  "auth_identity_passport": "Pasaporte",
  "auth_identity_national_document": "Documento nacional",
  "auth_document": "Documento",
  "auth_nationality": "Nacionalidad",
  "auth_birthdate": "Fecha de nacimiento",
  "auth_identity_type_cpf": "Soy una persona natural",
  "auth_identity_type_cnpj": "Soy una entidad legal",
  "auth_is_foreign": "Soy extranjero",
  "auth_termsRead": "He leído y acepto los ",
  "auth_terms": "Condiciones de Uso",
  "auth_termsAnd": " y ",
  "auth_policy": "Política de Privacidad",
  "auth_requiredCheckOfTermsAndPrivacyPolicy": "Debe aceptar los Términos y la Política de privacidad para continuar.",
  "auth_terms_close": "cerrar",
  "auth_terms_loading": "Cargando ...",
  "auth_signup": "Registrar",
  "auth_recoverPassword": "Recuperar contraseña",
  "auth_backToLogin": "Volver para iniciar sesión",
  "auth_code": "Código",
  "auth_resetPassword": "redefinir contraseña",
  "auth_goBackButton": "Volver",
  "auth_loginSubtitle": "Solo utilizamos datos imprescindibles para generar el bono de consumo",
  "auth_passwordResetSubtitle": "Ingrese el correo electrónico registrado en la plataforma para recuperar la contraseña",
  "auth_validCodeSubtitle": "Ingrese el código de 6 dígitos que se envió a",
  "auth_continue": "Continuar",
  "auth_didNotGetTheEmail": "No recibiste el email?",
  "auth_clickHere": "Haga clic aquí",
  "auth_passwordRecoverySubtitle": "Ingrese su nueva contraseña a continuación para completar el proceso de restablecimiento de contraseña",
  "auth_redefinePassword": "Redefinir contraseña",
  "auth_messagePasswordModifiedSuccessFully": "Tu contraseña ha sido cambiada exitosamente!",
  "auth_resendEmailInfo": "El código será reenviado al siguiente correo electrónico:",
  "auth_fixEmail": "Arreglar correo electrónico",
  "auth_messageAccountCreatedSuccessFully": "Su cuenta ha sido creada con éxito!",
  "auth_continueShopping": "Seguir comprando",
  "auth_emailUniquenessError_title": "Correo electrónico ya registrado",
  "auth_emailUniquenessError_message": "Hemos identificado que ya te has registrado en un establecimiento que utiliza la tecnología de comercio electrónico de Planne, así que procede a crear una nueva contraseña para realizar un inicio de sesión simplificado.<br></br><br></br >Tus datos están seguros y solo se comparte con empresas autorizadas por usted.",
  "auth_emailUniquenessError_action": "Crear nueva contraseña",
  "auth_zipCode_max_length_error": "El código postal debe tener 8 dígitos",

  "auth_verify_phone_form_title": "Ingrese la clave de acceso",
  "auth_verify_phone_form_subtitle": "Ingresa el código enviado por SMS al teléfono:",
  "auth_verify_phone_form_code": "Código",
  "auth_verify_phone_form_did_not_receive": "¿No recibiste el sms?",
  "auth_verify_phone_form_resend": "Reenviar",
  "auth_verify_phone_form_submit": "Continuar",
  "auth_verify_phone_form_back": "Volver",
  "auth_verify_phone_form_code_expires_in": "Puedes solicitar un nuevo código en",
  "auth_invalid_verification_code": "El código debe tener 6 caracteres",

  "cart_label": "Carrito:",
  "checkout_confirmingYourPurchase": "Confirmando su compra...",
  "checkout_awaiting_confirmation_message": "Estamos verificando la disponibilidad. Espere un momento antes de pagar.",
  "checkout_awaiting_confirmation_unavailable_title": "No hay disponibilidad",
  "checkout_awaiting_confirmation_unavailable_description": "No fue posible confirmar su reserva. Elija otra fecha u horario e intente nuevamente.",
  "checkout_awaiting_confirmation_unavailable_action": "Elegir otra fecha u horario",
  "checkout_pendingSales": "Ventas pendientes:",
  "checkout_saleNumber": "Venta #{saleNumber}",
  "checkout_item": "Item",
  "checkout_totalValue": "Valor total:",
  "checkout_yourCartIsEmpty": "¡Su carrito está vacío!",
  "checkout_yourCartErrors": "El carrito tiene los seguientes errores:",
  "checkout_continueShopping": "Continuar comprando",
  "checkout_finishSale": "Finalizar mi compra",
  "checkout_placement": "Lugares:",
  "checkout_resource_extra_value": "Adicional para lugares:",
  "checkout_additionals": "Adicionales",
  "checkout_invalidCoupon": "Cupón inválido",
  "checkout_removeCoupon": "Eliminar cupón",
  "checkout_couponCode": "Código promocional",
  "checkout_addCoupon": "Añadir cupón de descuento",
  "checkout_processingPayment": "Espere, el pago se está procesando...",
  "checkout_expiredSale": "Venta expirada",
  "checkout_makeYourPurchaseAgain": "Por favor, intente hacer su compra nuevamente",
  "checkout_percentDiscount": "% de descuento",
  "checkout_unavailablePaymentOptions": "Opciones de pago no disponibles",
  "checkout_unavailablePaymentMethod": "Método de pago no disponible.",
  "checkout_securityCode": "Código de seguridad",
  "checkout_validityMonth": "Mes de validez",
  "checkout_validityYear": "Año de validez",
  "checkout_formInputPhonePlaceholder": "(99) 99999-9999",
  "checkout_formInputEmailPlaceholder": "tu@mejoremail.com",
  "checkout_formInputCpfPlaceholder": "000.000.000-00",
  "checkout_paymentIn": "Pagar en",
  "checkout_addressTitle": "Dirección",
  "checkout_addressZipCode": "Código Postal (CEP)",
  "checkout_addressCountry": "País",
  "checkout_addressState": "Estado",
  "checkout_addressStateHint": "Sólo la sigla. Ex.: RJ",
  "checkout_addressCity": "Ciudad",
  "checkout_addressDistrict": "Barrio",
  "checkout_addressStreet": "Dirección",
  "checkout_addressNumber": "Número",
  "checkout_addressComplement": "Complemento",
  "checkout_nameAsInCard": "Nombre",
  "checkout_nameAsInCardHint": "Como se muestra en la tarjeta.",
  "checkout_identityMessage": "CPF del titular de la tarjeta (si está vacío, se utilizará CPF/CNPJ {num})",
  "checkout_expiredTry": "Su intento anterior ha caducado, inténtelo de nuevo.",
  "checkout_fromValue": " De ",
  "checkout_toValue": " por ",
  "checkout_payWithPix": "Pagar con Pix",
  "checkout_copiedCode": "Código copiado!",
  "checkout_finishPaymentWithPix": "¡Finalice el pago con Pix!",
  "checkout_pixUseCameraDescription": "Puedes usar la cámara de su celular para leer el Código QR o copiar el código y pagar en la app de su banco:",
  "checkout_verifyingPayment": "Comprobando el pago",
  "checkout_qrCodeWithPixCode": "Código QR con código Pix",
  "checkout_copyCode": "Copiar código",
  "checkout_completePurchaseStepsTitle": "Para completar su compra, siga los pasos a seguir.",
  "checkout_ongoingPixDescription": "Todavía tienes que pagar Pix.    Puede usar la opción de pagar con código QR o copiar y pegar el código y completar el pago usando su aplicación preferida    o su banca por internet.",
  "checkout_remove": "Eliminar",
  "checkout_confirm": "Confirme el monto mostrado, que debe ser igual al monto cobrado para evitar cancelar la transacción, y las informaciónes del destinatario (nombre de la institución financiera:",
  "checkout_nameOfReceiver": "nombre de la empresa receptora:",
  "checkout_atention": "Aviso:",
  "checkout_warning1": "<strong>No pague utilizando la función Transferir</strong> <span>, porque la </span> <strong>transacción no se completará y la devolución no se realizará automáticamente </strong> <span>, lo que requiere que se comunique con nuestro Centro de Servicio. </span>",
  "checkout_warning2": "<span>El período de confirmación de pago tarda en </span>    <strong>promedio de 10 segundos</strong>    <span> y depende de la institución financiera, por lo que el tiempo de procesamiento puede extenderse.</span>",
  "checkout_warning3": "<strong>El código QR es válido durante 5 minutos</strong> <intervalo>. Si no le pagan dentro de ese tiempo, necesitará</span> <strong> generar un nuevo código Pix.</strong>",
  "checkout_units": "unidad(s)",
  "checkout_method_softdescriptor": "En el extracto de la tarjeta, esta compra aparece en nombre de",
  "checkout_cardNumber": "Número de tarjeta",
  "checkout_postalCode": "Código Postal",
  "checkout_buyerInfoCollectHeaderTitle": "Informaciones adicionales",
  "checkout_buyerInfoCollectSubtitle": "Solo utilizamos datos imprescindibles para generar el bono de consumo",
  "checkout_buyerInfoCollectProceed": "Continuar",
  "checkout_buyerInfoCollectStepback": "Regresar",
  "checkout_buyerInfoCollectFillWithSignupData": "Rellene los datos proporcionados en el registro",
  "checkout_tariff": "Tarifa",
  "checkout_step_login": "Entrar",
  "checkout_step_signup": "Registrar",
  "checkout_step_personal": "Datos personales",
  "checkout_step_payment": "Detalles del pago",
  "checkout_step_payment_security_note": "Todas las compras realizadas en este sitio son 100% seguras, incluidos sus datos personales y los datos de su tarjeta.",
  "checkout_purchase_summary": "Resumen da compra",
  "checkout_order_summary_title": "Resumen del pedido",
  "checkout_coupon_placeholder": "Cupón de descuento",
  "checkout_coupon_apply": "Aplicar",
  "checkout_coupon_affected_products": "Descuento aplicado solo a los productos:",
  "checkout_view_more": "Ver más",
  "checkout_view_product_details": "Ver detalles de los productos",
  "checkout_sold_by": "Vendido por",
  "checkout_tariffs_section": "Tarifas",
  "checkout_view_summary": "Ver resumen",
  "checkout_hide_summary": "Ocultar resumen",
  "checkout_discounts": "Descuentos",
  "checkout_cart_summary_total": "Total: {total}",
  "checkout_cart_summary_products": "({count, plural, one {{count, number} producto} other {{count, number} productos}})",
  "checkout_title": "Finalizar compra",
  "checkout_back_to_site": "Volver al sitio",
  "checkout_back": "Volver",
  "checkout_auth_identification_title": "Accede a tu cuenta",
  "checkout_auth_identification_subtitle": "Crea o accede a tu cuenta",
  "checkout_auth_email_label": "Correo electrónico",
  "checkout_auth_identification_cta": "Continuar",
  "checkout_auth_or_divider": "O",
  "checkout_auth_required_field": "Campo obligatorio",
  "checkout_auth_invalid_email": "Correo electrónico inválido",
  "checkout_auth_generic_error_title": "No fue posible continuar",
  "checkout_auth_generic_error": "No fue posible procesar su solicitud ahora. Inténtelo de nuevo en un momento.",
  "checkout_auth_generic_error_retry": "Intentar de nuevo",
  "checkout_auth_login_title": "Accede a tu cuenta",
  "checkout_auth_login_existing_account_subtitle": "Este email está asociado a una cuenta en nuestros marketplaces. Ingresa tu contraseña para continuar o, si prefieres, recibe un código por email para continuar sin contraseña.",
  "checkout_auth_login_password_subtitle": "Ingresa tu email y contraseña para continuar o, si prefieres, recibe un código por email para continuar sin contraseña.",
  "checkout_auth_login_otp_subtitle": "Enviamos un código de 6 dígitos a <strong>{email}</strong>, ingrésalo abajo para continuar.",
  "checkout_auth_password_label": "Contraseña",
  "checkout_auth_show_password": "Mostrar contraseña",
  "checkout_auth_hide_password": "Ocultar contraseña",
  "checkout_auth_forgot_password_prefix": "¿Olvidaste tu contraseña?",
  "checkout_auth_forgot_password_link": "Haz clic aquí para recuperar",
  "checkout_auth_continue_cta": "Continuar",
  "checkout_auth_continue_purchase_cta": "Continuar compra",
  "checkout_auth_login_with_code_cta": "Entrar con código",
  "checkout_auth_login_with_password_cta": "Entrar con contraseña",
  "checkout_auth_otp_label": "Ingresa el código enviado",
  "checkout_auth_otp_helper": "Enviamos un código a tu correo electrónico",
  "checkout_auth_otp_resend_countdown": "Reenviar código en {seconds}s",
  "checkout_auth_otp_resend_cta": "Reenviar código",
  "checkout_auth_otp_sending": "Enviando código...",
  "checkout_auth_signup_link": "¿Es tu primera compra? Regístrate",
  "checkout_auth_signup_title": "Crea tu cuenta",
  "checkout_auth_signup_subtitle": "Completa tus datos para continuar con la compra.",
  "checkout_auth_signup_identity_type_label": "Tipo de cuenta",
  "checkout_auth_signup_person_title": "Soy persona física",
  "checkout_auth_signup_person_subtitle": "Actúo con mi CPF",
  "checkout_auth_signup_company_title": "Soy persona jurídica",
  "checkout_auth_signup_company_subtitle": "Actúo con mi CNPJ",
  "checkout_auth_signup_first_name_label": "Nombre",
  "checkout_auth_signup_last_name_label": "Apellido",
  "checkout_auth_signup_legal_first_name_label": "Nombre del representante legal",
  "checkout_auth_signup_legal_last_name_label": "Apellido del representante legal",
  "checkout_auth_signup_corporate_name_label": "Razón social",
  "checkout_auth_signup_cpf_label": "CPF",
  "checkout_auth_signup_cnpj_label": "CNPJ",
  "checkout_auth_signup_phone_label": "Celular",
  "checkout_auth_signup_legal_phone_label": "Celular del representante legal",
  "checkout_auth_signup_foreign_checkbox": "Soy extranjero",
  "checkout_auth_signup_nationality_label": "Nacionalidad",
  "checkout_auth_signup_foreign_document_label": "Documento",
  "checkout_auth_signup_foreign_document_type_label": "Tipo de documento",
  "checkout_auth_signup_foreign_document_identity": "Documento nacional",
  "checkout_auth_signup_foreign_document_passport": "Pasaporte",
  "checkout_auth_signup_zip_code_label": "CEP",
  "checkout_auth_signup_postal_code_label": "Código postal (Opcional)",
  "checkout_auth_signup_postal_code_hint": "Déjalo en blanco si tu país no usa código postal.",
  "checkout_auth_signup_zip_code_help_link_label": "No sé mi CEP",
  "checkout_auth_signup_zip_code_help_title": "¿No sabes tu CEP?",
  "checkout_auth_signup_zip_code_help_intro": "Usamos tu CEP para confirmar tus datos con más seguridad en el pago.",
  "checkout_auth_signup_zip_code_help_tip_before": "Verifica en una cuenta de luz/agua reciente, correspondencia recibida, o busca en el",
  "checkout_auth_signup_zip_code_help_link": "sitio de Correios",
  "checkout_auth_signup_zip_code_help_tip_after": ".",
  "checkout_auth_signup_zip_code_help_close": "Cerrar",
  "checkout_auth_signup_state_label": "Estado",
  "checkout_auth_signup_city_label": "Ciudad",
  "checkout_auth_signup_district_label": "Barrio",
  "checkout_auth_signup_street_label": "Calle",
  "checkout_auth_signup_number_label": "Número",
  "checkout_auth_signup_complement_label": "Complemento",
  "checkout_auth_signup_password_confirmation_label": "Confirmar contraseña",
  "checkout_auth_signup_password_hint": "Mínimo de 8 caracteres, con al menos una letra mayúscula, una minúscula y un número",
  "checkout_auth_signup_password_confirmation_hint": "Repite la contraseña",
  "checkout_auth_signup_terms_prefix": "He leído y acepto los",
  "checkout_auth_signup_terms_of_use": "Términos de uso",
  "checkout_auth_signup_terms_connector": "y la",
  "checkout_auth_signup_privacy_policy": "Política de privacidad",
  "checkout_auth_signup_secure_purchase": "Compra 100% segura",
  "checkout_auth_signup_confirm_cta": "Confirmar",
  "checkout_auth_signup_email_in_use_title": "Correo ya registrado",
  "checkout_auth_signup_email_in_use_message": "Ya existe una cuenta con este correo. Inicia sesión o recupera tu contraseña para continuar.",
  "checkout_auth_signup_email_in_use_login": "Iniciar sesión",
  "checkout_auth_signup_email_in_use_recover": "Crear contraseña",
  "checkout_auth_signup_email_not_found_title": "No pudimos confirmar este correo",
  "checkout_auth_signup_email_not_found_message": "Revisa que esté bien escrito o usa otra dirección para crear tu cuenta.",
  "checkout_auth_signup_invalid_cpf": "CPF inválido",
  "checkout_auth_signup_invalid_cnpj": "CNPJ inválido",
  "checkout_auth_signup_invalid_zip_code": "El CEP debe tener 8 dígitos",
  "checkout_auth_signup_invalid_phone": "Ingresa un celular válido",
  "checkout_auth_signup_weak_password": "La contraseña debe tener al menos 8 caracteres, con una letra mayúscula, una minúscula y un número",
  "checkout_auth_signup_password_mismatch": "Las contraseñas no coinciden",
  "checkout_auth_signup_terms_required": "Debes aceptar los términos para continuar",
  "checkout_auth_signup_recaptcha_required": "Confirma que no eres un robot",
  "checkout_auth_signup_foreign_cnpj_conflict": "El registro de persona jurídica no está disponible para extranjeros",
  "auth_login_submit_cta": "Iniciar sesión",
  "auth_login_password_subtitle": "Ingresa tu contraseña para acceder a tu cuenta.",
  "auth_login_signup_link": "¿No tienes una cuenta? Regístrate",
  "checkout_auth_signup_page_title": "Crea tu cuenta",
  "checkout_auth_reset_password_page_title": "Restablecimiento de contraseña",
  "checkout_auth_recovery_title": "Recuperación de contraseña",
  "checkout_auth_recovery_email_subtitle": "Ingresa el correo registrado y te enviaremos un código de 6 dígitos para verificar tu identidad.",
  "checkout_auth_recovery_otp_subtitle": "Enviamos un código de 6 dígitos al correo <strong>{email}</strong>. Ingrésalo abajo para continuar con la recuperación de contraseña.",
  "checkout_auth_recovery_new_password_title": "Restablecer contraseña",
  "checkout_auth_new_password_label": "Nueva contraseña",
  "checkout_auth_confirm_password_label": "Confirmar contraseña",
  "checkout_auth_password_min_length_helper": "Tu contraseña debe contener al menos 8 caracteres",
  "checkout_auth_password_repeat_helper": "Repite la contraseña",
  "checkout_auth_reset_password_cta": "Restablecer contraseña",
  "checkout_auth_back_cta": "Volver",
  "checkout_auth_did_not_receive_email": "¿No recibiste el correo?",
  "checkout_auth_resend_email_link": "Haz clic aquí para reenviar",
  "checkout_auth_otp_code_label": "Ingresa el código",
  "checkout_auth_otp_code_invalid": "Código incorrecto. Revisa los caracteres e inténtalo de nuevo.",
  "checkout_auth_email_placeholder": "Ingresa tu correo",
  "checkout_auth_password_mismatch": "Las contraseñas deben coincidir",
  "checkout_auth_password_strength": "La contraseña debe contener al menos 8 caracteres, incluyendo mayúsculas, minúsculas y números",
  "checkout_pix_proceed_description": "Haga clic en continuar para generar el código QR de pago único y continuar con su compra.",
  "checkout_continue_pix": "Continuar",
  "checkout_card_owner_cpf_cnpj": "CPF/CNPJ del Titular del Cartón",
  "checkout_valid_date": "Fecha de validez (MM/AA)",
  "checkout_complete_purchase": "Completar compra",
  "checkout_disapproved_warning": "Aviso!",
  "checkout_disapproved_intro": "Compra desaprobada",
  "checkout_disapproved_try_again": "Intentar otra vez",
  "checkout_purchase_summary_day": "Dia",
  "checkout_purchase_summary_without_date": "Sin programación",
  "checkout_payment_successful": "Pago realizado con exito",
  "checkout_payment_successful_redirect": "Ver compra",
  "checkout_payment_anti_fraud_error": "Comprueba si los datos son correctos o utiliza otro método de pago.",
  "checkout_payment_transaction_error": "Compruebe si los datos son correctos o póngase en contacto con el banco emisor de la tarjeta.",
  "checkout_payment_generic_transaction_error": "Hubo un error al procesar su transacción. Espere unos momentos y vuelva a intentarlo.",
  "checkout_payment_unauthorized_error": "La sesión expiró. Por favor identifíquese y vuelva a intentarlo.",
  "checkout_payment_discount_chip": "{percentage}% de descuento",
  "checkout_payment_installments_chip": "Hasta {count}x sin intereses",
  "checkout_payment_card_number": "Número de la tarjeta",
  "checkout_payment_card_holder": "Nombre del titular",
  "checkout_payment_card_holder_identity": "CPF o CNPJ del titular",
  "checkout_payment_card_zip_code": "Código postal (CEP)",
  "checkout_payment_card_postal_code": "Código postal",
  "checkout_payment_card_security_code": "Código de seguridad (CVV)",
  "checkout_payment_card_installments": "Número de cuotas",
  "checkout_secure_purchase": "Compra 100% segura",
  "checkout_additional_info_invalid_cpf": "CPF inválido",
  "checkout_additional_info_invalid_phone": "Teléfono inválido",
  "checkout_additional_info_invalid_date": "Fecha inválida",
  "checkout_additional_info_title": "Complete la información importante sobre su reserva",
  "checkout_additional_info_subtitle": "Solo utilizamos datos esenciales para generar el voucher de consumo",
  "checkout_additional_info_fill": "Completar información",
  "checkout_additional_info_edit": "Editar",
  "checkout_additional_info_review": "Revisar",
  "checkout_additional_info_filled": "Completado",
  "checkout_additional_info_not_filled": "No completado",
  "checkout_additional_info_partially_filled": "{filled} de {total} completados",
  "checkout_additional_info_needs_review": "Revise la información",
  "checkout_additional_info_continue": "Continuar",
  "checkout_additional_info_next": "Siguiente",
  "checkout_additional_info_done": "Finalizar",
  "checkout_additional_info_save": "Guardar",
  "checkout_additional_info_cancel": "Cancelar",
  "checkout_additional_info_error_alert": "Revise la información destacada",
  "checkout_additional_info_progress": "{filled}/{total}",
  "checkout_payment_card_submit": "Finalizar compra",
  "checkout_payment_card_validity_must_be_valid": "La validez debe tener el formato MM/AA",
  "checkout_payment_card_foreign_alert_title": "Compras internacionales",
  "checkout_payment_card_foreign_alert_description": "Tu banco puede bloquear compras internacionales. Activa “Aviso de Viaje” o “Uso Internacional” en la app de tu banco. El banco también puede pedir una confirmación para autorizar la compra.",
  "checkout_payment_pix_step_generate": "Haz clic en <strong>Generar código Pix</strong> para seguir con la compra",
  "checkout_payment_pix_step_confirm": "Revisa los datos y realiza el pago desde la app de tu banco",
  "checkout_payment_pix_secure_purchase": "Compra 100% segura",
  "checkout_payment_pix_generate_button": "Generar código Pix",
  "checkout_payment_pix_change_method": "Cambiar forma de pago",
  "checkout_payment_pix_change_method_compact": "Cambiar método de pago",
  "checkout_payment_pix_title": "Paga con Pix",
  "checkout_payment_pix_description": "Puedes usar la cámara de tu celular para leer el código QR o copiar el código y pagar en la app de tu banco.",
  "checkout_payment_pix_time_remaining": "Tiempo restante para pagar:",
  "checkout_payment_pix_copy_button": "Copiar código",
  "checkout_payment_pix_copied_tooltip": "Código pix copiado",
  "checkout_payment_pix_how_to_title": "Cómo pagar con Pix:",
  "checkout_payment_pix_how_to_1": "Abre la app o el sitio del banco de tu preferencia.",
  "checkout_payment_pix_how_to_2": "Elige la opción “pagar con Pix Copia y Pega” o código QR.",
  "checkout_payment_pix_how_to_3": "Copia y pega el código o escanea el código QR;",
  "checkout_payment_pix_how_to_4": "Espera unos segundos. Tu pedido se confirmará cuando se complete el pago",
  "checkout_payment_pix_expired_title": "El código Pix expiró",
  "checkout_payment_pix_expired_description": "Si ya realizaste el pago, tu pedido puede tardar hasta 5 minutos en confirmarse",
  "checkout_payment_pix_expired_retry": "Intentar de nuevo",
  "checkout_payment_pix_receiver_disclaimer": "Al pagar el Pix, el nombre de la institución aparecerá como “<strong>{institution}</strong>”",
  "checkout_payment_account_title": "Cuenta",
  "checkout_payment_account_edit": "Editar",
  "checkout_payment_step_title": "Pago",
  "checkout_payment_step_subtitle": "Elige una opción de pago:",
  "checkout_phone_verification_alert_message": "Necesitas confirmar tu número de teléfono",
  "checkout_phone_verification_alert_button": "Confirmar",
  "checkout_sale_change_previous_reservation": "Reserva actual",
  "checkout_sale_change_new_reservation": "Nueva reserva",

  "checkout_confirmed_greeting": "¡Gracias, {name}!",
  "checkout_confirmed_title": "Pago confirmado",
  "checkout_confirmed_description": "Ya puedes descargar tus vouchers. También fueron enviados por correo electrónico y están disponibles en tu cuenta cuando los necesites",
  "checkout_confirmed_additionals": "Adicionales",
  "checkout_confirmed_additionals_overflow": "+{count}",
  "checkout_confirmed_additionals_show_more": "Ver más",
  "checkout_confirmed_reschedule": "Reprogramar",
  "checkout_confirmed_reschedule_available": "Reprogramaciones disponibles: <span>{count}</span>",
  "checkout_confirmed_reschedule_deadline": "Plazo para solicitar la reprogramación: <span>{deadline}</span>",
  "checkout_confirmed_reschedule_deadline_antecedence": "Hasta {antecedence} antes de la reserva",
  "checkout_confirmed_reschedule_expired": "El plazo para reprogramar ha expirado",
  "checkout_confirmed_reschedule_unavailable": "No es posible reprogramar reservas promocionales. Contacta al establecimiento para más información.",
  "checkout_confirmed_reschedule_package_tooltip": "Las reservas de paquete se reprograman en conjunto. Contacta al establecimiento.",
  "checkout_confirmed_vouchers_count": "Vouchers: {count}",
  "checkout_confirmed_vouchers_view_all": "Ver todos",
  "checkout_confirmed_vouchers_pending_tooltip": "Los vouchers aún se están emitiendo. Inténtalo de nuevo en unos instantes.",
  "checkout_confirmed_download_all_vouchers": "Descargar todos los vouchers",

  "checkout_order_details_title": "Detalles del pedido",
  "checkout_order_details_email": "Correo electrónico",
  "checkout_order_details_account_type": "Tipo de cuenta",
  "checkout_order_details_account_type_individual": "Persona física",
  "checkout_order_details_account_type_company": "Persona jurídica",
  "checkout_order_details_first_name": "Nombre",
  "checkout_order_details_last_name": "Apellido",
  "checkout_order_details_representative_first_name": "Nombre del representante legal",
  "checkout_order_details_representative_last_name": "Apellido del representante legal",
  "checkout_order_details_corporate_name": "Razón social",
  "checkout_order_details_country": "País de origen",
  "checkout_order_details_cpf": "CPF",
  "checkout_order_details_cnpj": "CNPJ",
  "checkout_order_details_national_document": "Documento nacional",
  "checkout_order_details_passport": "Pasaporte",
  "checkout_order_details_phone": "Celular",
  "checkout_order_details_payment_method": "Método de pago",
  "checkout_order_details_installments": "Número de cuotas",
  "checkout_order_details_installments_value": "{count}x de {amount}",
  "checkout_order_details_zip_code": "Código postal",

  "checkout_payment_method_credit_card": "Tarjeta de crédito",
  "checkout_payment_method_debit_card": "Tarjeta de débito",
  "checkout_payment_method_pix": "Pix",
  "checkout_payment_method_post_paid": "Facturado",

  "checkout_vouchers_modal_code": "Código",
  "checkout_vouchers_modal_password": "Contraseña",
  "checkout_vouchers_modal_status": "Estado",
  "checkout_vouchers_modal_status_open": "No utilizado",
  "checkout_vouchers_modal_status_consumed": "Utilizado",
  "checkout_vouchers_modal_status_revoked": "Cancelado",
  "checkout_vouchers_modal_status_pending": "Esperando confirmación",
  "checkout_vouchers_modal_download": "Descargar voucher",
  "checkout_vouchers_modal_tariff_quantity": "{count}x {name}",

  "checkout_payment_gateway_mismatch_error_title": "No se puede proceder con el pago",
  "checkout_payment_gateway_mismatch_error_description": "Hubo un error en la información financiera del responsable de la venta. Para continuar con su compra, comuníquese con nuestro soporte.",
  "checkout_payment_gateway_mismatch_error_ok": "OK",
  "checkout_payment_gateway_blocked_buyer_error_title": "No se puede procesar el pago",
  "checkout_payment_gateway_blocked_buyer_error_helper_text": "Has excedido el límite máximo de intentos. Para continuar con tu compra utiliza otro método de pago",

  "checkout_error_foreignCustomerNotAllowed": "Esta aplicación no permite compras de extraños. Por favor, entre en contacto con el establecimiento para obtener más información.",
  "checkout_foreign_buyer_alert_badge": "IMPORTANTE",
  "checkout_foreign_buyer_alert_title": "Compras internacionales",
  "checkout_foreign_buyer_alert_description": "Tu banco puede bloquear compras internacionales. Activa <strong>“Aviso de Viaje”</strong> o <strong>“Uso Internacional”</strong> en la app de tu banco. El banco también puede pedir <strong>una confirmación para autorizar la compra.</strong>",

  "timeout_error_title": "No se puede comunicar con el servidor",
  "timeout_error_description": "Ups, tuvimos un problema al comunicarnos con el servidor. Espere unos momentos y vuelva a intentarlo.",
  "timeout_error_ok": "Aceptar",

  "checkout_pix_payment_insufficient_amount_title": "Monto insuficiente para pago vía Pix",
  "checkout_pix_payment_insufficient_amount_description": "Añade más productos al carrito o utiliza otro método de pago",

  "adder_dataSelected": "Fecha seleccionada: ",
  "adder_buy": "Comprar",
  "adder_goBack": "volver",
  "adder_quantity": "Cant",
  "adder_hour": "Selecciona un horario",
  "adder_unavailableQuantity": "Cantidad no disponible",
  "adder_outOfStock": "Agotado",
  "adder_additionals": "Adicionales",
  "adder_additionals_perPerson": "p/ tarifa",
  "adder_additionals_remain": "Permanecer",
  "adder_additionals_soldOff": "Vendido",
  "adder_productAddedToCart": "¡Producto agregado al carrito!",
  "adder_productNotAddedToCart": "Producto no agregado al carrito",
  "adder_seeCart": "Ver mi carrito",
  "adder_perPerson": "por persona",
  "adder_singleErrorLabel": "La cantidad seleccionada para esta tarifa no está disponible",
  "adder_multipleErrorLabel": "La cantidad de las tarifas seleccionadas ha superado el límite para esta fecha",
  "adder_dependent_tariff": "Dependiente",
  "adder_dependent_tariff_selection_error": "Seleccione al menos una tarifa que no sea dependiente para continuar",
  "adder_hours_unavailable_error": "Horarios no disponibles para el número de tarifas seleccionadas",
  "adder_additionals_custom_type_quantity_placeholder": "Introduzca la cantidad deseada",
  "adder_additionals_custom_type_quantity_error": "La cantidad debe ser mayor que cero",
  "adder_additionals_custom_type_max_quantity_error": "La cantidad máxima permitida es {maxQuantity}",
  "adder_seats_missing_tariffs_unavailable_error": "No encontramos asientos disponibles para estas tarifas y horarios seleccionados. Para continuar, agregue más {missing} tarifa(s) a su selección o pruebe con otro horario disponible.",
  "adder_seats_unavailable_error": "No se encontraron lugares disponibles para las tarifas y el horario seleccionados. Para continuar, elige otro día/horario disponible.",
  "adder_error_generic": "No fue posible agregar esta selección al carrito. Revise los datos e inténtelo de nuevo.",
  "adder_error_tariff_quantity_limit": "La cantidad seleccionada supera el límite permitido para esta tarifa. Reduzca la cantidad para continuar.",
  "adder_error_tariff_unavailable": "No hay disponibilidad para la cantidad seleccionada. Reduzca la cantidad o elija otra fecha/horario.",
  "adder_error_additional_unavailable": "No hay disponibilidad para los adicionales seleccionados. Revise la selección para continuar.",
  "adder_error_schedule_unavailable": "La fecha u horario seleccionado ya no está disponible. Elija otra opción para continuar.",
  "adder_error_seats_unavailable": "No hay lugares suficientes para la cantidad seleccionada. Reduzca la cantidad o elija otro horario.",
  "adder_error_seats_missing_capacity": "Faltan {missing} lugar(es) para la cantidad seleccionada en este horario. Reduzca la cantidad o elija otro horario.",
  "adder_error_product_unavailable": "Este producto no está disponible para la compra en este momento.",
  "adder_tariff_verification_field_required": "Este campo es obligatorio",
  "adder_tariff_verification_validation_error": "Datos de comprobaciones inválidos",
  "adder_tariff_verification_document_validation_error": "El número de documento proporcionado no es válido o no cumple con los criterios requeridos para esta tarifa.",
  "adder_tariff_verification_date_validation_error": "La fecha de nacimiento proporcionada no cumple con los criterios requeridos para esta tarifa.",

  "sale_totalValue": "Valor total: ",
  "sale_termExpired": "El plazo de pago de este pedido ha vencido.",
  "sale_printAll": "Imprimir todo",
  "sale_print": "Imprimir",
  "sale_productColumn": "Produto",
  "sale_dateColumn": "Fecha",
  "sale_hourColumn": "Hora",
  "sale_quantityColumn": "Cantidad",
  "sale_codeColumn": "Voucher",
  "sale_passwordColumn": "Contraseña",
  "sale_stateColumn": "Estado",
  "sale_noAvailableReservation": "¡No hay reservas disponibles!",
  "sale_reschedule": "Reprogramar",
  "sale_unavailableReschedule": "¡Reprogramación no disponible!",
  "sale_awaitingDate": "Esperando una fecha...",
  "sale_consumed": "Consumido",
  "sale_open": "Abierto",
  "sale_goBack": "Volver",

  "seatMap_selectOneTime": "Seleccione solamente un horario",
  "seatMap_tariffUnits": "Unidad(es)",
  "seatMap_pendingAllocationQuantity": "Cantidad asignada:",
  "seatMap_pendingTariffAllocation": "Algunas tarifas aún no han sido asignadas",
  "seatMap_resourceMinValue": "Valor del lugar",
  "seatMap_filledCapacity": "lugares",
  "seatMap_resourceSubAllocationNotice": "La cantidad de tarifas asignadas a la mesa es menor a la permitida, seleccione otra mesa.",
  "seatMap_resourceReservationPrice": "Adicional para lugares",
  "seatMap_totalPrice": "Total",
  "seatMap_canvas_subtitles": "Subtítulos",
  "seatMap_tariff_price_cents": "Valor de la tarifa",
  "seatMap_selectSeat": "Seleccione el asiento",

  "awaiting_confirmation": "En espera de confirmación",
  "created": "En abierto",
  "pending": "Pendiente",
  "expired": "Vencida",
  "confirmed": "Confirmado",
  "payment_complete": "Pago confirmado",
  "payment_voided": "Pago anulado",
  "payment_chargeback": "Cancelada",
  "payment_charged_back": "Cancelada",
  "payment_denied": "Cancelada",
  "canceled": "Cancelada",
  "available": "Disponible",
  "selected": "Selecionado",
  "blocked": "Bloqueado",
  "unavailable": "Indisponible",
  "no_option_found": "Ninguna opción encontrada",

  "january": "Enero",
  "february": "Febrero",
  "march": "Marzo",
  "april": "Abril",
  "may": "mayo",
  "june": "junio",
  "july": "julio",
  "august": "agosto",
  "september": "septiembre",
  "october": "octubre",
  "november": "noviembre",
  "december": "diciembre",
  "monday": "lunes",
  "tuesday": "martes",
  "wednesday": "miércoles",
  "thursday": "jueves",
  "friday": "viernes",
  "saturday": "sábado",
  "sunday": "domingo",

  "cart_item_remove_error": "Error al eliminar el artículo del carrito. Inténtalo de nuevo o contacta con el vendedor.",
  "cart_package_error": "Cualquier artículo ha sido cambiado o eliminado por el vendedor, elimine el artículo del carrito.",
  "discount_fallback_warning_message": "El descuento de este producto ha sido cambiado por el vendedor.",
  "cart_package_details": "detalles de los productos",
  "cart_item_price_summary_previous": "Precio anterior",
  "cart_iconLabel": "Su carrito tiene {quantity} artículos",
  "cart_loading": "Cargando carrito de compras",
  "cart_header": "Carrito de Compras",
  "cart_totalLabel": "Total",
  "cart_subtotal": "Subtotal",
  "cart_final_value": "Valor final",
  "cart_coupon_text": "Cupón",
  "cart_itemErrorWarning": "Este artículo ha sido modificado por el proveedor. Retírelo del carrito.",
  "cart_value": "Valor",
  "cart_checkout": "Checkout",
  "cart_discount": "Desconto",
  "cart_apply": "Aplicar",
  "cart_cancel": "Remover",
  "cart_openAreaApplyVoucher": "Abrir area para aplicar o cupom",
  "cart_closeAreaApplyVoucher": "Fechar area de aplicar o cupom",
  "cart_voucherTitle": "Cupom de Desconto",
  "cart_selectedDate": "Data",
  "cart_selectedLanguage": "Idioma",
  "cart_selectedTariff": "Tarifa",
  "cart_selectedResources": "Lugar Selecionado",
  "cart_additionals": "Additionals",
  "cart_itens": "Itens",
  "cart_backToHome": "Voltar a Pagina inicial",
  "cart_pleaseWait": "Por favor aguarde!",
  "cart_yourCartIsEmpty": "Your cart is empty",
  "cart_addProductInstruction": "Adiciona um produto ao carrinho",
  "cart_closeCart": "Close cart modal",
  "cart_quantity": "Cantidad",
  "cart_remove_discount_button": "Remover",
  "cart_discount_coupon_button_title": "Añadir cupón de descuento",
  "cart_discount_coupon_submit_button": "Agregar",
  "cart_discount_coupon_applied_succefully": "Cupón de descuento aplicado",
  "cart_discount_coupon_product": "Solo producto:",
  "cart_discount_coupon_product_list": "Sólo para productos:",
  "cart_package_date": "Fecha:",
  "cart_package_tariff": "Tarifas:",
  "cart_package_previous_price": "Precio anterior",
  "cart_package_discount": "Descuento",
  "cart_package_total": "Total",
  "cart_package_product_details": "Detalles del producto",

  "adder_step_calendar": "Seleccione una fecha",
  "adder_step_tariff": "Selecione a tarifa",
  "adder_selected_date": "Data selecionada",
  "adder_step_seat_map": "Seleciona um lugar",
  "adder_step_additional": "Selecione os adicionais",
  "adder_step_finish": "Adiciona ao carrito",
  "adder_step_package_quantity": "Selecciona la cantidad",
  "adder_priceAccordingToSchedule": "según el tiempo",
  "adder_day": "Dia",
  "adder_night": "Noite",
  "adder_price_per_unit": "Preco por item",
  "adder_goBackFooter": "Voltar",
  "adder_goForwardsFooter": "Continuar",
  "adder_purchaseButton": "Comprar",
  "adder_serviceFee": "Se podrán cobrar tasas.",
  "adder_selectedTariff": "Tarifa Selecionada",
  "adder_selectedResources": "Lugar Selecionado",
  "adder_legend_current": "Dia atual",
  "adder_legend_available": "Disponivel",
  "adder_legend_unavailable": "Indisponivel",
  "adder_legend_suggested_prices": "Precios sujetos a cambio",
  "adder_legend_suggested_prices_tooltip": "El precio mostrado puede variar dependiendo del horario o tarifa elegida",
  "adder_legend_busy": "Alta Temporada",
  "adder_unavailableTariffNotice": "Vendido",
  "adder_tryAgain": "Intentar nuevamente",
  "adder_price_from": "De",
  "adder_price_to": "Para",
  "adder_updating_price": "Actualizando…",
  "adder_price_update_failed": "No se pudo actualizar el precio. Mostrando el último valor.",

  "terms_of_use": "Condiciones de Uso",
  "privacy_policy": "Política de Privacidad",

  "direct_link_sale_title": "Carro",
  "direct_link_payment_title": "Pago",
  "direct_link_pay_button": "Pagar",
  "direct_link_finished_payment_message": "Pago completado",
  "direct_link_finished_sale_message": "Compra completada",
  "direct_link_cancelled_message": "Enlace cancelado",
  "direct_link_checkout_error_couponHasUsesLeft": "El cupón utilizado en el carrito no tiene más usos disponibles. Póngase en contacto con la propiedad para obtener más información.",
  "direct_link_checkout_error_resourceMustBeAvailable": "Lugar no disponible",
  "direct_link_checkout_error_tariffOccupationMustBeRespected": "No quedan más plazas disponibles para esta tarifa en el horario elegido",

  "coupon_code": "¡Cupón no válido!",
  "coupon_expires_at": "Cupón caducado",
  "coupon_max_use": "El cupón ha superado el número máximo de usos",
  "coupon_max_use_per_user": "¡Ups! Ya has utilizado este cupón el número máximo de veces permitido",
  "coupon_invalid_for_these_products": "Cupón no aplicable a productos seleccionados.",

  "open_purchase_title": "Finalizar el pago",
  "open_purchase_description": "Tienes una compra pendiente, ¿quieres continuar?",
  "open_purchase_button_text": "Sí",

  "direct_link_required_field": "Campo obligatorio",

  "customer_form_invalid_document": "Documento no válido",
  "customer_form_email_does_not_match": "El email no coincide",
  "customer_form_invalid_birthdate": "Fecha de nacimiento no válida",

  "direct_link_invalid_message": "Enlace no válido",
  "direct_link_expired_message": "Enlace caducado",

  "direct_link_auth_step_title": "Detalles de contacto",
  "direct_link_payment_step_title": "Pago",
  "direct_link_summary_title_payment": "Resumen de pago",
  "direct_link_summary_title_sale": "Resumen de compra",

  "direct_link_auth_message": "Tus entradas se enviarán a la dirección de correo electrónico proporcionada. Introduce una dirección de correo electrónico válida",
  "direct_link_auth_email_label": "Correo electrónico",
  "direct_link_auth_continue": "Continuar",

  "direct_link_auth_login_title": "Iniciar sesión",
  "direct_link_auth_login_or": "O",
  "direct_link_auth_login_with_otp": "Iniciar sesión con clave de acceso",
  "direct_link_auth_login_with_password": "Iniciar sesión con contraseña",

  "direct_link_user_form_email_label": "Correo electrónico",
  "direct_link_user_form_email_confirmation_label": "Confirmar correo electrónico",
  "direct_link_user_form_name_label": "Nombre",
  "direct_link_user_form_representative_legal_name_label": "Nombre del representante legal",
  "direct_link_user_form_lastname_label": "Apellido",
  "direct_link_user_form_representative_legal_lastname_label": "Apellido del representante legal",
  "direct_link_user_form_phone_label": "Teléfono",
  "direct_link_user_form_cpf_identity_label": "CPF",
  "direct_link_user_form_cnpj_identity_label": "CNPJ",
  "direct_link_user_form_birthday_label": "Fecha de nacimiento",
  "direct_link_user_form_zip_code_label": "CEP",
  "direct_link_user_form_corporate_name_label": "Razón corporativa",
  "direct_link_user_form_terms_message": "Al continuar con la compra estarás aceptando los ",
  "direct_link_user_form_terms_message_use_terms": "Términos",
  "direct_link_user_form_terms_message_and": " y las ",
  "direct_link_user_form_terms_message_privacy_policy": "Políticas de Privacidad",
  "direct_link_user_form_continue": "Continuar",
  "direct_link_user_form_identity_type_cpf": "Soy una persona natural",
  "direct_link_user_form_identity_type_cnpj": "Soy una entidad legal",
  "direct_link_user_form_corporate_name": "Nombre de empresa",
  "direct_link_user_form_is_foreign": "Soy extranjero",
  "direct_link_user_form_nationality": "Nacionalidad",
  "direct_link_user_form_document": "Documento",
  "direct_link_user_form_identity_national_document": "Documento de nacimiento",
  "direct_link_user_form_identity_passport": "Pasaporte",

  "direct_link_password_form_title": "Ingrese la contraseña para iniciar sesión",
  "direct_link_password_form_password_label": "Contraseña",
  "direct_link_password_form_login": "Iniciar sesión",
  "direct_link_password_form_forgot_password": "¿Olvidaste tu contraseña?",

  "direct_link_forgot_password_modal_title": "Restablecer contraseña",

  "direct_link_reset_password_form_title": "Ingresa el código que te enviamos por correo electrónico",
  "direct_link_reset_password_code_label": "Código de acceso",
  "direct_link_reset_password_code_expires": "El código caduca en",
  "direct_link_reset_password_sending_code": "Enviando código...",
  "direct_link_reset_password_resend_code": "Reenviar código",
  "direct_link_reset_password_cancel": "Cancelar",
  "direct_link_reset_password_confirm": "Confirmar",

  "direct_link_change_password_form_title": "Ingrese una nueva contraseña",
  "direct_link_change_password_form_password_label": "Nueva contraseña",
  "direct_link_change_password_form_password_confirmation_label": "Confirmar nueva contraseña",
  "direct_link_change_password_form_cancel": "Cancelar",
  "direct_link_change_password_form_confirm": "Confirmar",
  "direct_link_change_password_password_match": "Las contraseñas no coinciden",

  "direct_link_auth_login_otp_form_title": "Ingresa el código que te enviamos por correo electrónico",
  "direct_link_auth_login_otp_form_code_label": "Código de acceso",
  "direct_link_auth_login_otp_form_login": "Iniciar sesión",
  "direct_link_auth_login_otp_form_code_expires": "El código caduca en",
  "direct_link_auth_login_otp_form_sending_code": "Enviando código...",
  "direct_link_auth_login_otp_form_resend_code": "Reenviar código",

  "direct_link_summary_date_and_time": "Fecha y hora",
  "direct_link_summary_subtotal": "Subtotal",
  "direct_link_summary_coupon": "Cupón",
  "direct_link_summary_discount": "Descuento",
  "direct_link_summary_total": "Total",

  "direct_link_validate_phone_message": "Necesitas validar tu teléfono",
  "direct_link_validate_phone_validate": "Validar",
  "direct_link_validate_phone_modal_title": "Informar clave de acceso",

  "direct_link_phone_verification_form_title": "Ingresa el código que te enviamos por SMS a tu teléfono:",
  "direct_link_phone_verification_form_code_label": "Código de acceso",
  "direct_link_phone_verification_form_code_expires": "El código caduca en",
  "direct_link_phone_verification_form_sending_code": "Enviando código...",
  "direct_link_phone_verification_form_resend_code": "Reenviar código",
  "direct_link_phone_verification_form_submit": "Continuar",

  "direct_link_card_form_submit": "Pagar",
  "direct_link_card_form_identity_must_be_valid": "El número debe ser válido",
  "direct_link_card_form_postal_code_must_be_valid": "El código postal debe ser válido",
  "direct_link_card_form_postal_code_must_have_8_digits": "El código postal debe tener 8 dígitos",
  "direct_link_card_form_card_number_must_be_valid": "La tarjeta debe ser válida",
  "direct_link_card_form_card_brand_not_accepted": "La marca de la tarjeta no es aceptada",
  "direct_link_card_form_card_expired": "La tarjeta no puede caducar",
  "direct_link_card_form_holder_helper": "Como dice la tarjeta",

  "direct_link_pix_form_step_1_title": "Pagarás con PIX",
  "direct_link_pix_form_step_1_description": "La confirmación del pago tarda sólo unos minutos. Utilice la aplicación de su banco para pagar.",
  "direct_link_pix_form_step_1_pix_amount": "Cantidad en PIX:",
  "direct_link_pix_form_step_1_finish": "Pagar",

  "direct_link_pix_form_step_2_instruction": "Abre tu aplicación de pago y elige la opción <strong>Leer código QR</strong>",
  "direct_link_pix_form_step_2_camera_instruction": "Apunta la cámara de tu teléfono al código QR",
  "direct_link_pix_form_step_2_copy_code": "Copiar código",
  "direct_link_pix_form_step_2_code_copied": "¡Copiado!",
  "direct_link_pix_form_step_2_verifying_payment": "Verificando pago",
  "direct_link_card_form_validity_placeholder": "MM/AA",

  "direct_link_pix_form_steps_step_1": "Completa la compra haciendo clic en \"Pagar\"",
  "direct_link_pix_form_steps_step_2": "Lee el código QR con la aplicación de tu banco o copia la clave PIX",
  "direct_link_pix_form_steps_step_3": "Después de la confirmación del pago, su reserva quedará confirmada",

  "direct_link_payment_success_alert": "¡Pago realizado!",
  "direct_link_payment_success_message": "Nos complace informarle que su pago se ha recibido exitosamente.",
  "direct_link_payment_success_voucher_message": "Para más detalles, descarga tu Cupón.",
  "direct_link_payment_success_download_vouchers": "Descargar todos los cupones",

  "direct_link_min_code_length": "El código debe tener al menos 6 caracteres",
  "direct_link_max_code_length": "El código debe tener un máximo de 6 caracteres.",

  "direct_link_min_password_length": "La contraseña debe tener al menos 8 caracteres",
  "direct_link_password_strength": "La contraseña debe contener al menos 8 caracteres, con al menos una letra mayúscula y una letra minúscula",

  "direct_link_user_form_terms_modal_title": "Condiciones de Uso",
  "direct_link_user_form_privacy_policy_modal_title": "Politicas de Privacidad",

  "direct_link_zipCode_max_length_error": "El código postal debe tener 8 dígitos",

  "cashback_growth_modal_title": "¡Tu compra generó cashback!",
  "cashback_growth_modal_store_hint": "Vales en <strong>parques</strong>, <strong>restaurantes</strong> y <strong>paseos parceiros</strong>.",
  "cashback_growth_modal_deadline": "Canjea tu cashback por WhatsApp. El plazo para usarlo comienza cuando lo canjeas.",
  "cashback_growth_redeem_whatsapp": "Canjear por WhatsApp",
  "cashback_growth_redeem_short": "Canjear",
  "cashback_growth_decline": "No quiero cashback",
  "cashback_growth_card_with_name": "{name}, tu compra generó cashback para usar en restaurantes, paseos y atracciones en la Serra Gaúcha. El plazo para usarlo empieza cuando lo canjeas.",
  "cashback_growth_card_without_name": "Tu compra generó cashback para usar en restaurantes, paseos y atracciones en la Serra Gaúcha. El plazo para usarlo empieza cuando lo canjeas.",

  "partnership_banner_discount": "¡{value} descuento!",
  "partnership_banner_message": "¡Compre ahora y obtenga {value} de descuento de {affiliateName}! El cupón <strong>{couponCode}</strong> se aplicará automáticamente a su carrito.",
  "partnership_banner_continue": "Continuar",

  "recaptcha_validation_error": "Por favor, confirma que no eres un robot",

  "phone_verification_title": "¡Casi llegamos!",
  "phone_verification_subtitle": "Introduce el código enviado vía SMS al teléfono",
  "phone_verification_submit_button": "Ingresar",

  "invalid_value": "¡Cupón inválido!",
  "coupon_is_active": "Cupón no aplicable para estas fechas.",
  "coupon_has_uses_left": "El cupón ha superado el límite máximo de usos.",
  "coupon_has_customer_uses_left": "¡Ups! Ya has utilizado este cupón el número máximo de veces permitidas.",
  "coupon_has_some_products": "¡El cupón no es aplicable a los productos seleccionados!",
  "coupon_purchase_min_amount_cents_not_reached": "No se alcanzó el valor mínimo del cupón. Agrega más artículos al carrito para continuar con el descuento.",
  "coupon_has_some_valid_item": "¡El cupón no es aplicable a los productos seleccionados!",

  "product_package_adder_product_list_title": "Products",
  "product_package_adder_total": "Total",
  "product_package_adder_selection_step_calendar": "Elige una fecha para: ",
  "product_package_adder_selection_step_tariff": "Elige una tarifa para: ",
  "product_package_adder_selection_step_seat_map": "Elige asientos para: ",
  "product_package_adder_selection_step_additional": "Elige adicional para: ",
  "product_package_adder_add_to_cart_button": "Añadir a la cesta",
  "product_package_adder_complete_selection_description": "Se han configurado todos los productos en el combo {packageName} con actividades {productQuantity}",
  "product_package_cancel_modal_title": "¿Quieres cerrar el paquete?",
  "product_package_cancel_modal_description": "Al cerrar la configuración del paquete se eliminarán todos los productos configurados.",
  "product_package_cancel_modal_action_no": "No",
  "product_package_cancel_modal_action_yes": "Sí",
  "product_package_error_while_load_package_data": "Se produjo un error al cargar los datos del paquete. Por favor, contacte con el establecimiento.",
  "product_package_error_empty_package": "Parece que este paquete no tiene ningún producto disponible para la venta. Por favor, contacte con el establecimiento.",
  "product_package_error_has_inactive_product": "¡Ops! Uno de los productos de este paquete no está disponible para la venta. Por favor, contacte con el establecimiento.",
  "product_package_error_while_load_package_products_data": "Se produjo un error al cargar los productos del paquete. Por favor, contacte con el establecimiento.",
  "product_package_single_booking_unavailable": "Este paquete no está disponible para las opciones seleccionadas.",
  "product_package_single_booking_quantity_step_title": "Elige la cantidad de tarifas para todos los productos del paquete",
  "product_package_single_booking_chosen_date": "Fecha elegida",
  "product_package_single_booking_additional_fees": "Pueden cobrarse tasas adicionales",
  "product_package_adder_sold_by": "Vendido por: {owner}",
  "checkout_bin_code_validation_error": "La tarjeta de crédito informada no está calificada para la adquisición de las tarifas seleccionadas. Utilice otra tarjeta.",

  "tds_generic_error": "Erro al procesar el pago",
  "tds_transaction_failed": "Fallo en el pago",
  "tds_transaction_denied": "Pago negado",
  "tds_invalid_transactable": "Transacción inválida",

  "currency_warning_message": "Los valores mostrados en otras monedas son solo de referencia. El cobro se realizará en Real brasileño (BRL).",

  "cart_serviceFee": "Tarifa de servicio",
  "cart_serviceFee_tooltip": "La tarifa de servicio se utiliza para el mantenimiento y operación de la plataforma.",

  "product_booking_add_to_cart": "Agregar al carrito",
  "product_booking_date_placeholder": "Seleccione una fecha",
  "product_booking_language_placeholder": "Seleccione el idioma",
  "product_booking_attribute_placeholder": "Seleccione el {attribute}",
  "product_booking_attribute_no_option_found": "Ninguna opción encontrada",
  "product_booking_attribute_loading": "Cargando...",
  "product_booking_attribute_pickup_zone_label": "Lugar de embarque",
  "product_booking_tariff_placeholder": "Seleccione una tarifa",
  "product_booking_tariff_summary": "{count, plural, one {{count, number}x Tarifa} other {{count, number}x Tarifas}}",
  "product_booking_additionals_summary": "{count, plural, one {{count, number}x Adicional} other {{count, number}x Adicionales}}",
  "product_booking_service_fee_note": "Pueden aplicarse tarifas de servicio",
  "product_booking_no_tariffs": "No hay tarifas disponibles para esta fecha",
  "product_booking_tariff_max_availability_reached": "Se alcanzó la cantidad máxima disponible para este producto",
  "product_booking_trust_instant_title": "Confirmación instantánea",
  "product_booking_trust_instant_description": "Recibe tu voucher inmediatamente por correo electrónico.",
  "product_booking_trust_secure_title": "Pago seguro",
  "product_booking_trust_secure_description": "Tus datos están protegidos.",
  "product_booking_price_in_up_to_installments": "Hasta {count}x",
  "product_booking_price_interest_free": "Sin intereses",
  "product_booking_price_or_at_sight": "o {price} al contado",
  "product_booking_price_starting_from": "A partir de",
  "product_booking_price_at_sight_label": "Al contado",
  "product_booking_price_at_sight_compact": "{price} al contado",
  "product_booking_total_label": "TOTAL DE LA RESERVA",
  "product_booking_total_at_sight_suffix": "al contado",
  "product_booking_view_summary": "Ver resumen",
  "product_booking_additionals": "Selecciona adicional (Opcional)",
  "product_booking_quantity_minus": "Disminuir cantidad",
  "product_booking_quantity_plus": "Aumentar cantidad",
  "product_booking_select_date_first": "Seleccione una fecha primero",
  "product_booking_select_language_first": "Seleccione un idioma primero",
  "product_booking_select_tariff_first": "Seleccione una tarifa primero",
  "product_booking_select_time_first": "Seleccione una hora primero",
  "product_booking_select_seat_map_first": "Complete la selección de asientos primero",
  "product_booking_select_additionals_first": "Complete los campos obligatorios de adicionales primero",
  "product_booking_select_attribute_first": "Seleccione {attribute} primero",
  "product_booking_trending_reservations": "{count, plural, one {{count, number} persona reservó} other {{count, number} personas reservaron}} en las últimas 24 horas",
  "product_upsell_modal_title": "¡Agregado al carrito!",
  "product_upsell_modal_description": "Aprovecha para asegurar ahora otras experiencias increíbles recomendadas por nuestros especialistas.",
  "product_upsell_sold_by": "Vendido por: {owner}",
  "product_upsell_price_prefix": "A partir de",
  "product_upsell_add_offer": "Agregar {product}",
  "product_upsell_remove_offer": "Quitar {product}",
  "product_upsell_selected_count": "{count, plural, one {{count, number} ítem seleccionado} other {{count, number} ítems seleccionados}}",
  "product_upsell_no_thanks": "No, gracias",
  "product_upsell_continue": "Continuar",
  "upsell_booking_cancel_title": "¿Descartar upsell?",
  "upsell_booking_cancel_description": "Si cierras ahora, todos los productos adicionales serán descartados y serás redirigido al carrito solo con el producto principal.",
  "upsell_booking_cancel_action_no": "Continuar",
  "upsell_booking_cancel_action_yes": "Descartar",
  "upsell_booking_product_list_title": "Productos seleccionados",
  "upsell_booking_completed_description": "Todos los productos han sido configurados",
  "code_input_value_label": "Valor {index} de {length}",

  "checkout_payment_error_declined_title": "No fue posible completar tu compra con esta tarjeta",
  "checkout_payment_error_declined_body": "Por tu seguridad, este pago fue rechazado por nuestro sistema de protección. Revisa los datos de tu tarjeta o intenta con otra tarjeta.",
  "checkout_payment_error_declined_body_pix": "",
  "checkout_payment_error_issuer_title": "Pago no autorizado por tu banco",
  "checkout_payment_error_issuer_body": "El emisor de tu tarjeta rechazó la transacción. Esto puede ocurrir por fondos insuficientes, datos incorrectos o una restricción de seguridad. Revisa la información ingresada y verifica si tu banco requiere una confirmación para autorizar esta compra. También puedes intentar con otra tarjeta.",
  "checkout_payment_error_issuer_body_pix": "",
  "checkout_payment_error_secondary_pix": "Pagar con PIX",
  "checkout_payment_error_retry": "Intentar nuevamente",
  "checkout_payment_error_expired_title": "Tu pedido ha expirado",
  "checkout_payment_error_expired_description": "El tiempo para completar este pago ha terminado. Para asegurar tus productos, selecciónalos nuevamente y finaliza tu compra.",
  "checkout_payment_error_expired_retry": "Intentar otra vez"
}
